import { simpleStringCompare } from 'utils';

export function filterRidesByStatus(rides, ...statuses) {
  return rides.filter(function (ride) {
    return statuses.includes(ride.ride_status);
  });
}

export function filterRidesByPlacedStatus(rides) {
  return rides.filter(function (ride) {
    return ride.finish_position;
  });
}

export function filterRidesByAlsoRan(rides) {
  return rides.filter(function (ride) {
    return !ride.finish_position && !ride.casualty.status;
  });
}

export function filterRidesByCasualty(rides) {
  return rides.filter(function (ride) {
    return !ride.finish_position && ride.casualty.status;
  });
}

export function sortByFinishPosition(a,b) {
  if ((a.amended_position || a.finish_position) < (b.amended_position || b.finish_position)){
    return -1;
  }

  if ((a.amended_position || a.finish_position) > (b.amended_position || b.finish_position)){
    return 1;
  }

  if ((a.amended_position || a.finish_position) === (b.amended_position || b.finish_position)) {
    if (a.finish_distance === "dh" && b.finish_distance !== "dh") {
      return 1;
    }

    if (b.finish_distance === "dh" && a.finish_distance !== "dh") {
      return -1;
    }
  }

  return 0;
}

function sortDetails({
  cloth_number,
  horse: {
    name
  } = {},
  ride_reference: {
    id
  } = {}
}) {
  return {
    cloth_number,
    name,
    id
  };
}

// this needs to be super safe, because horse early entries can be a pain
export function sortByClothNo(...rides) {
  const [a, b] = rides.map(sortDetails);

  if (a.cloth_number && b.cloth_number) {
    return a.cloth_number - b.cloth_number;
  }
  else if (a.name && b.name) {
    return simpleStringCompare(a.name, b.name);
  }
  else if (a.id && b.id) {
    return a.id - b.id;
  }

  return 0;
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/utils/rideFilter.js